import { forwardRef } from "react";

import { RadioField } from "@/components/global/form/inputs/radio-field";
import { RadioFieldLayout } from "@/components/global/form/layouts/radio-field-layout";

interface RadioGroupProps {
  options: Array<{
    value: string;
    label: string;
    dataCy?: string;
  }>;
  error?: string;
  isValid?: boolean;
  disabled?: boolean;
  radioFieldLayout?: {
    className?: string;
  };
  [key: string]: any;
}

export const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
  (
    {
      options,
      error: _error,
      isValid: _isValid,
      disabled,
      radioFieldLayout,
      ...props
    },
    ref,
  ) => {
    return (
      <>
        <RadioFieldLayout className={radioFieldLayout?.className}>
          {options.map((option: RadioGroupProps["options"][number]) => (
            <RadioField
              key={option.value}
              ref={ref}
              value={option.value}
              label={option.label}
              dataCy={option.dataCy}
              disabled={disabled}
              {...props}
            />
          ))}
        </RadioFieldLayout>
      </>
    );
  },
);

RadioGroup.displayName = "RadioGroup";
